
































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "kpi-cards",
})
export default class Kpi extends Vue {
    @Prop({ required: true })
    labelDesks!: string;

    @Prop({ required: true })
    labelOccupancy!: string;

    @Prop({ required: true })
    labelReservationsWeekly!: string;

    @Prop({ required: true })
    valueDesks!: any;

    @Prop({ required: true })
    valueOccupancy!: any;

    @Prop({ required: true })
    valueReservationsWeekly!: any;

    @Prop({ required: false })
    tooltipDesks!: string;

    @Prop({ required: false })
    tooltipOccupancy!: string;

    @Prop({ required: false })
    tooltipReservationsWeekly!: string;

    @Prop({ default: "white" })
    color!: any;

    @Prop()
    dataCy: string;
}
